"use client";

import React, { useEffect } from 'react';

const GoogleAnalytics = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: GoogleAnalytics is not implemented yet.');
  }, []);
  return (
    <>
  { /*GoogleAnalytics */} 
 </>
  );
};

export { GoogleAnalytics };